// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  width?: number;
  fill?: string;
};
export const Time = ({ fill = 'none', width = 12 }: Props) => (
  <chakra.svg
    height={`${width}px`}
    width={`${width}px`}
    fill={fill}
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 10.9995C3.23857 10.9995 1 8.76091 1 5.99951C1 3.23809 3.23857 0.999512 6 0.999512C8.7614 0.999512 11 3.23809 11 5.99951C11 8.76091 8.7614 10.9995 6 10.9995ZM6 9.99951C8.20915 9.99951 10 8.20866 10 5.99951C10 3.79037 8.20915 1.99951 6 1.99951C3.79086 1.99951 2 3.79037 2 5.99951C2 8.20866 3.79086 9.99951 6 9.99951ZM6.5 5.99951H8.5V6.99951H5.5V3.49951H6.5V5.99951Z"
      fill="url(#paint0_linear_1849_8113)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1849_8113"
        x1="1.72917"
        y1="2.35368"
        x2="9.64583"
        y2="10.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ABEA45" />
        <stop offset="1" stopColor="#12D0A2" />
      </linearGradient>
    </defs>
  </chakra.svg>
);
